import excelJs from 'exceljs';
import { MicrobiologyData, NutritionalData}  from "../stores"

const workbook = new excelJs.Workbook();

const Micro_sheet = workbook.addWorksheet('Microbiology');

const Nutri_sheet = workbook.addWorksheet('Physicochemical');



Micro_sheet.columns = [

  { header: 'Product', key: 'Product', width: 20 },
  { header: 'Batch', key: 'Batch ID', width: 20 },
  { header: 'Batch Size', key: 'Batch Size', width: 20 },
  { header: 'Type of Data', key: 'Type of Data', width: 20 },
  { header: 'Number of Samples', key: 'Number of Samples', width: 20 },
  { header: 'Trial', key: 'Trial', width: 20 },
  { header: 'Production Date', key: 'Production Date', width: 20 },
  { header: 'Bacteria', key: 'Bacteria', width: 20 },
  { header: 'Mean', key: 'Mean', width: 20 },
  { header: 'Positive Samples', key: 'Positive Samples', width: 20 },
  { header: 'Standard Deviation', key: 'Standard Deviation', width: 20 },  
  { header: 'Minimum', key: 'Minimum', width: 20 },
  { header: 'Maximum', key: 'Maximum', width: 20 }
];

Nutri_sheet.columns = [

  { header: 'Product', key: 'Product', width: 20 },
  { header: 'Batch', key: 'Batch ID', width: 20 },
  { header: 'Batch Size', key: 'Batch Size', width: 20 },
  { header: 'Type of Data', key: 'Type of Data', width: 20 },
  { header: 'Number of Samples', key: 'Number of Samples', width: 20 },
  { header: 'Trial', key: 'Trial', width: 20 },
  { header: 'Production Date', key: 'Production Date', width: 20 },
  { header: 'Property', key: 'Property', width: 20 },
  { header: 'Mean', key: 'Mean', width: 20 },
  { header: 'Standard Deviation', key: 'Standard Deviation', width: 20 }  
];


let microbiology = Object.keys(MicrobiologyData[0]).reduce((o, key) => ({ ...o, [key]: null}), {});
let nutritional = Object.keys(NutritionalData[0]).reduce((o, key) => ({ ...o, [key]: null}), {});



const calculateStd = (dataArray,mean) =>{

	let sum = 0;
	let variance = 0;
	let std = 0;
	let n = dataArray.length;

	for(let i = 0 ; i < dataArray.length; i++){

		let auxValue = parseFloat(dataArray[i]) - mean;
		auxValue = Math.pow(auxValue,2);
		sum = sum + auxValue;
	}

	variance = sum/n;
	std = Math.sqrt(variance).toPrecision(3);
	return std;

}


export const convertData = async (data) => {


	let res = '';

	let microRows = [];
	let nutriRows = [];



	for(let index = 0 ; index < data.length ; index++){

		let generalRow = [];
		let microRow = [];
		let nutriRow = [];

		let dataType = data[index]['DataType'];

		// var numberOfSamples =parseInt(data[index]['numberOfSamples']);

		generalRow.push(data[index]['Product']);
		generalRow.push(data[index]['BatchID']);
		generalRow.push(data[index]['BatchSize']);
		generalRow.push(dataType);
		generalRow.push(data[index]['NumberOfSamples']);
		generalRow.push(data[index]['Trial']);
		generalRow.push(data[index]['ProductionDate']);

		if(dataType == 'Mean'){

				const sampleArray = data[index]['Samples'];

				if(sampleArray[0].Microbiology){

					const microbiologyObj = sampleArray[0].Microbiology;

					for(const [key,value] of Object.entries(microbiology)){

								if(microbiologyObj[key]){
									var minKey = key + '_Min';
									var maxKey = key + '_Max';

									microRow.push(key)

									//detection
									if(key == 'Salmonella' || key == 'ListeriaAbs'){

										microRow.push('NA');
										microRow.push(parseInt(microbiologyObj[key]));
										microRow.push('NA');
										microRow.push('NA');
										microRow.push('NA');
									}
									//not detection
									else{
										microRow.push(parseFloat(microbiologyObj[key]));
										microRow.push('NA');
										microRow.push('NA');
										microRow.push(microbiologyObj[minKey]);
										microRow.push(microbiologyObj[maxKey]);	
									}
									

									let finalMicroRow = generalRow.concat(microRow);
									microRows.push(finalMicroRow);
									microRow = [];	
								}
								

					}

				}
				 
				if(sampleArray[0].Nutritional){

					const nutritionalObj = sampleArray[0].Nutritional;

					for(const [key,value] of Object.entries(nutritional)){
						
							if(nutritionalObj[key]){

								var StdKey = key + '_Std';

								nutriRow.push(key);
								nutriRow.push(nutritionalObj[key]);
								nutriRow.push(nutritionalObj[StdKey]);

								let finalNutriRow = generalRow.concat(nutriRow);

								nutriRows.push(finalNutriRow);
								nutriRow = [];

						}
					}
				}

		}
		else if(dataType == 'Individual'){

			const sampleArray = data[index]['Samples'];


			for(const [key,value] of Object.entries(microbiology)){

						let valuesArray = [];
						let microMean = 0;
						let microMin = Number.POSITIVE_INFINITY;
						let microMax = 0;
						let microStd = 0;
						let n = 0;
						let positiveSamples = 0;

						// console.log('****', key, '*****');
						for(let i = 0 ; i < sampleArray.length; i++){

							if(sampleArray[i].Microbiology){
								var microbiologyObj = sampleArray[i].Microbiology;

								if(microbiologyObj[key]){
										
										if(key == 'Salmonella' || key == 'ListeriaAbs'){
											if(microbiologyObj[key] != 'Select'){
												positiveSamples += parseInt(microbiologyObj[key]);	
											}
											 
										}
										else{
											n++;
											// valuesArray.push(parseFloat(microbiologyObj[key]));
											valuesArray.push(microbiologyObj[key]);
											microMean = microMean + parseFloat(microbiologyObj[key]);
											if(parseInt(microbiologyObj[key]) < microMin){
												microMin = parseFloat(microbiologyObj[key]);
											}

											if(parseInt(microbiologyObj[key]) > microMax){
												microMax = parseFloat(microbiologyObj[key]);
											}
										}

										


								}

							}
							else{

							}

						}

						if(key == 'Salmonella' || key == 'ListeriaAbs'){
							microRow.push(key);
							microRow.push('NA');
							microRow.push(positiveSamples);
							microRow.push('NA');
							microRow.push('NA');
							microRow.push('NA');
							let finalMicroRow = generalRow.concat(microRow);
							microRows.push(finalMicroRow);
							positiveSamples = 0;
							microRow = [];
						}
						else{
							if(microMean != 0 ){
								microRow.push(key);
								microMean = (microMean/n).toPrecision(3);
								microRow.push(microMean);
								microRow.push('NA');
								microStd = await calculateStd(valuesArray, microMean);
								microRow.push(microStd);
								microRow.push(microMin);
								microRow.push(microMax);


								let finalMicroRow = generalRow.concat(microRow);
								microRows.push(finalMicroRow);
								microRow = [];
								valuesArray = [];	
								microMean = 0;
								microMin = Number.POSITIVE_INFINITY;
								microMax = 0;
								microStd = 0;

								n = 0;
							}
						}
			}

			for(const [key,value] of Object.entries(nutritional)){

						let valuesArray = [];
						let nutriMean = 0;
						let nutriStd = 0;
						let n = 0;

						for(let i = 0 ; i < sampleArray.length; i++){

							if(sampleArray[i].Nutritional){
								let nutritionalObj = sampleArray[i].Nutritional;

								if(nutritionalObj[key]){
										
										n++;
										valuesArray.push(parseFloat(nutritionalObj[key]));
										nutriMean = nutriMean + parseFloat(nutritionalObj[key]);

								}

							}
							else{

							}

						}

						if(nutriMean != 0){
							nutriRow.push(key);
							nutriMean = (nutriMean/n).toPrecision(3);
							nutriRow.push(nutriMean);
							nutriStd = await calculateStd(valuesArray, nutriMean);
							nutriRow.push(nutriStd);
							let finalNutriRow = generalRow.concat(nutriRow);
							nutriRows.push(finalNutriRow);
							nutriRow = [];	
						}
						
						
			}
					 
		}
		else{

			// error invalid dataType
		}

		generalRow = [];
		
	}


	let newRows1 = Micro_sheet.addRows(microRows);

	let newRows2 = Nutri_sheet.addRows(nutriRows);


	let buffer = await workbook.xlsx.writeBuffer();

	return buffer;

}